import { useSelector } from 'react-redux';

export default function useRoles() {
  const { user } = useSelector((state) => state.account);
  if (user && user.idTokenClaims) {
    const { roles } = user.idTokenClaims;
    return roles;
  }

  return [];
}
